module.exports = __webpack_public_path__ + "img/media-3.0b4f3bfe.png";